import type { ExperimentConfig } from '../@types'

const config: ExperimentConfig[] = [
	{
		'main-tai-chi-walking': {
			// /tai-chi-walking?mock-data&utm_source=welcome_topic_test&country=US&area=main-tai-chi-walking&exp=web_tai_chi_walking_gs_welcome_topic~1
			landing: {
				experiment: () => import('@/modules/Landing/instances/experiments/web_tai_chi_walking_gs_welcome_topic'),
			},
		},
	},
]

export default config
